var _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniArrowToRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 4,
    x2: 12,
    y2: 4,
    stroke: "#D91F05"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.3,
    y1: 0.6,
    x2: 12.3,
    y2: 3.6,
    stroke: "#D91F05"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8.64645,
    y1: 7.64645,
    x2: 12.6464,
    y2: 3.64645,
    stroke: "#D91F05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniArrowToRight);
export default __webpack_public_path__ + "static/media/mini_arrow_to_right.466dda53404c8a42d544819c74ea2cd8.svg";
export { ForwardRef as ReactComponent };